/**
 * 根据已选规格值 ID 拼接 SKU 展示名称。
 * 规则（与数据库文档一致）：仅拼接规格「值」的中文，以空格分隔。
 * 示例：spec_value 名 ["红色", "XL"] -> "红色 XL"
 *
 * @param {number[]} selectedSpecValueIds 已选规格值 ID 列表
 * @param {Object} specValueMap 规格值映射 { [id]: { name, spec_id } }
 * @returns {string}
 */
export function buildSkuName(selectedSpecValueIds = [], specValueMap = {}) {
  return (selectedSpecValueIds || [])
    .map((id) => specValueMap[id] && specValueMap[id].name)
    .filter(Boolean)
    .join(' ')
}

/**
 * 根据已选规格值 ID 拼接带「规格维度名」的 SKU 展示名称。
 * 规则：每个规格值拼成「规格名:规格值」，整体以空格分隔。
 * 示例：spec_value 名 ["红色", "XL"]（分别属于 颜色/尺码） -> "颜色:红色 尺码:XL"
 *
 * 相比 buildSkuName 仅拼接值，本函数能消除多维度下的值歧义（如同样的值「大」可能属于不同维度）。
 * 若某规格值取不到规格名，则回退为仅显示值，与 buildSkuName 行为一致。
 *
 * @param {number[]} selectedSpecValueIds 已选规格值 ID 列表
 * @param {Object} specValueMap 规格值映射 { [id]: { name, spec_id } }
 * @param {Object} specNameMap 规格（维度）名映射 { [spec_id]: specName }
 * @returns {string}
 */
export function buildSkuNameWithSpec(selectedSpecValueIds = [], specValueMap = {}, specNameMap = {}) {
  return (selectedSpecValueIds || [])
    .map((id) => {
      const v = specValueMap[id]
      if (!v || !v.name) return null
      const specName = (v.spec_id != null && specNameMap[v.spec_id]) || ''
      return specName ? `${specName}:${v.name}` : v.name
    })
    .filter(Boolean)
    .join(' ')
}

/**
 * 将 SKU-规格值关联列表转换为「已选规格值 ID 数组」。
 * @param {Array} skuSpecList getSkuSpecs 返回的 list
 * @returns {number[]}
 */
export function skuSpecListToValueIds(skuSpecList = []) {
  return (skuSpecList || []).map((item) => item.spec_value_id).filter(Boolean)
}
